"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEcommAppIdFilter = getEcommAppIdFilter;
exports.getEcommStoreIdFilter = getEcommStoreIdFilter;
exports.getFolderIdFilter = getFolderIdFilter;
exports.removeFilters = removeFilters;
exports.removeFiltersByProperty = removeFiltersByProperty;
exports.addUniqueFilters = addUniqueFilters;
exports.getPageLoadQuery = getPageLoadQuery;
exports.indexPageFilter = exports.productsAndFoldersFilter = exports.ecommApiFilter = exports.hubSpotProductsFilter = void 0;

var _immutable = require("immutable");

var _ProductProperties = require("customer-data-objects/product/ProductProperties");

var _ProductQuery = _interopRequireDefault(require("crm_data/products/ProductQuery"));

var PRODUCT_TYPE = 1;
var FOLDER_TYPE = 2;
var hubSpotProductsFilter = (0, _immutable.fromJS)([{
  operator: 'NOT_HAS_PROPERTY',
  property: _ProductProperties.ECOMM_SYNCED
}]); // Stop using this util, it is deprecated. Use getEcommStoreIdFilter below

exports.hubSpotProductsFilter = hubSpotProductsFilter;

function getEcommAppIdFilter(appId) {
  return (0, _immutable.fromJS)([{
    operator: 'EQ',
    property: _ProductProperties.ECOMM_APP_ID,
    value: appId
  }]);
} // Stop using this constant, it is deprecated. Use getEcommStoreIdFilter below


var ecommApiFilter = (0, _immutable.fromJS)([{
  operator: 'NOT_HAS_PROPERTY',
  property: _ProductProperties.ECOMM_APP_ID
}, {
  operator: 'HAS_PROPERTY',
  property: _ProductProperties.ECOMM_SYNCED
}]);
exports.ecommApiFilter = ecommApiFilter;

function getEcommStoreIdFilter(storeId) {
  return (0, _immutable.fromJS)([{
    operator: 'EQ',
    property: _ProductProperties.ECOMM_STORE_ID,
    value: storeId
  }]);
}

var productsAndFoldersFilter = (0, _immutable.fromJS)([{
  operator: 'IN',
  property: 'type',
  values: [PRODUCT_TYPE, FOLDER_TYPE]
}]);
exports.productsAndFoldersFilter = productsAndFoldersFilter;

function getFolderIdFilter(folderId) {
  if (folderId === null || folderId === undefined) {
    return (0, _immutable.fromJS)([{
      operator: 'NOT_HAS_PROPERTY',
      property: _ProductProperties.FOLDER_ID
    }]);
  }

  return (0, _immutable.fromJS)([{
    operator: 'EQ',
    property: _ProductProperties.FOLDER_ID,
    value: String(folderId)
  }]);
}

var indexPageFilter = productsAndFoldersFilter.concat(getFolderIdFilter(null));
exports.indexPageFilter = indexPageFilter;

function removeFilters(contactSearchQuery, filtersToRemove) {
  // Remove 'filtersToRemove' from all filterGroups in the contact search query
  return contactSearchQuery.update('filterGroups', function (filterGroups) {
    return filterGroups.reduce(function (acc, filterGroup) {
      var updatedFilterGroup = filterGroup.update('filters', function (queryFilters) {
        return queryFilters.filterNot(function (filter) {
          return filtersToRemove.includes(filter);
        });
      });
      return updatedFilterGroup.get('filters').isEmpty() ? acc : acc.push(updatedFilterGroup);
    }, (0, _immutable.List)());
  });
}

function removeFiltersByProperty(contactSearchQuery, propertiesToRemove) {
  return contactSearchQuery.update('filterGroups', function (filterGroups) {
    return filterGroups.reduce(function (acc, filterGroup) {
      var updatedFilterGroup = filterGroup.update('filters', function (queryFilters) {
        return queryFilters.filterNot(function (filter) {
          return typeof propertiesToRemove === 'string' ? filter.get('property') === propertiesToRemove : propertiesToRemove.includes(filter.get('property'));
        });
      });
      return updatedFilterGroup.get('filters').isEmpty() ? acc : acc.push(updatedFilterGroup);
    }, (0, _immutable.List)());
  });
}

function addUniqueFilters(contactSearchQuery, filtersToAdd) {
  // Add 'filtersToAdd' to all filterGroups in the contact search query
  return removeFilters(contactSearchQuery, filtersToAdd).update('filterGroups', function (filterGroups) {
    return filterGroups.isEmpty() ? filterGroups.push((0, _immutable.Map)({
      filters: filtersToAdd
    })) : filterGroups.map(function (filterGroup) {
      return filterGroup.update('filters', function (queryFilters) {
        return queryFilters.concat(filtersToAdd);
      });
    });
  });
}

function getPageLoadQuery(currentFolder) {
  var filtersToAdd = currentFolder ? getFolderIdFilter(currentFolder.folderId) : indexPageFilter;
  return addUniqueFilters(new _ProductQuery.default(), filtersToAdd);
}